import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import '../ManagedCDN.css';

const ManagedCDNHe = () => {
    return (
        <div dir="rtl">
            <Helmet>
                {/* Primary Meta Tags */}
                <title>שירות CDN ו-Cloudflare מנוהל - תפעול מקצועי | Epicfinal</title>
                <meta name="title" content="שירות CDN ו-Cloudflare מנוהל - תפעול מקצועי | Epicfinal" />
                <meta name="description" content="שירות CDN ו-Cloudflare מנוהל החל מ-$139.90 לחודש. תפעול מלא, WAF, הגנת DDoS, אופטימיזציית ביצועים, עד 4 דומיינים. רשת קצה גלובלית עם ניטור 24/7." />
                <meta name="keywords" content="CDN מנוהל, ניהול Cloudflare, אופטימיזציית CDN, רשת הפצת תוכן, הגנת DDoS, WAF, פיירוול אפליקטיבי, שירות CDN, Cloudflare מנוהל, CDN גלובלי, רשת קצה, ניטור CDN, הפצת וידאו, CDN למסחר אלקטרוני" />
                <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
                <meta name="author" content="Epicfinal" />
                <link rel="canonical" href="https://epicfinal.com/he/managed-cdn" />

                {/* Language & Locale */}
                <html lang="he" />
                <meta property="og:locale" content="he_IL" />
                <link rel="alternate" href="https://epicfinal.com/managed-cdn" hrefLang="en" />
                <link rel="alternate" href="https://epicfinal.com/he/managed-cdn" hrefLang="he" />

                {/* Open Graph / Facebook */}
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://epicfinal.com/he/managed-cdn" />
                <meta property="og:title" content="שירות CDN ו-Cloudflare מנוהל | Epicfinal" />
                <meta property="og:description" content="ניהול CDN מומחה ב-$139.90 לחודש. WAF, הגנת DDoS, אופטימיזציית ביצועים וניטור 24/7 לעד 4 דומיינים." />
                <meta property="og:image" content="https://epicfinal.com/android-chrome-512x512.png" />
                <meta property="og:image:alt" content="Epicfinal CDN מנוהל - תפעול מקצועי של Cloudflare" />
                <meta property="og:site_name" content="Epicfinal" />

                {/* Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:url" content="https://epicfinal.com/he/managed-cdn" />
                <meta name="twitter:title" content="שירות CDN ו-Cloudflare מנוהל | Epicfinal" />
                <meta name="twitter:description" content="ניהול CDN מומחה ב-$139.90 לחודש. WAF, הגנת DDoS וניטור 24/7." />
                <meta name="twitter:image" content="https://epicfinal.com/android-chrome-512x512.png" />

                {/* Schema.org Structured Data */}
                <script type="application/ld+json">{`
                    {
                        "@context": "https://schema.org",
                        "@type": "Service",
                        "name": "שירות CDN ו-Cloudflare מנוהל",
                        "description": "ניהול תפעולי מלא של CDN עם Cloudflare כולל ניטור, אופטימיזציה, WAF, הגנת DDoS ותחזוקה",
                        "provider": {"@type": "Organization", "name": "Epicfinal", "url": "https://epicfinal.com"},
                        "serviceType": "ניהול CDN",
                        "areaServed": "Worldwide",
                        "offers": {"@type": "Offer", "price": "139.90", "priceCurrency": "USD", "priceValidUntil": "2025-12-31", "availability": "https://schema.org/InStock"},
                        "url": "https://epicfinal.com/he/managed-cdn"
                    }
                `}</script>
            </Helmet>

            <div className="managed-cdn-page">
                {/* Hero Section */}
                <section className="cdn-hero">
                    <div className="container">
                        <div className="cdn-hero-content">
                            <div className="cdn-icon-badge">
                                <i className="las la-network-wired"></i>
                            </div>
                            <h1 className="cdn-hero-title">
                                שירות CDN ו-Cloudflare מנוהל
                            </h1>
                            <p className="cdn-hero-subtitle">
                                ניהול CDN מקצועי לביצועים ואבטחה אופטימליים
                            </p>
                            <p className="cdn-hero-description">
                                מפעילים את האתר שלכם מאחורי CDN וזקוקים לניהול מקצועי שוטף? אנחנו מטפלים בתפעול מלא של ה-CDN – ניטור, אופטימיזציה ותחזוקה – בין אם שרת המקור שלכם נמצא בדאטה סנטר שלנו או אצל כל ספק אחר בעולם, כך שהאתר שלכם נשאר מהיר, יציב ומאובטח.
                            </p>
                            <div className="cdn-hero-buttons">
                                <a href="https://my.epicfinal.com/index.php?rp=/store/managed-services/managed-cdn&language=hebrew&currency=2"
                                    className="btn-cdn btn-primary" target="_blank" rel="noopener noreferrer">
                                    הזמינו עכשיו - ₪499.90 לחודש
                                </a>
                                <Link to="/contact1" className="btn-cdn btn-secondary">
                                    דברו עם מומחה
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Features Section */}
                <section className="cdn-features">
                    <div className="container">
                        <div className="cdn-section-header">
                            <h2>למה לבחור בשירות ה-CDN המנוהל שלנו?</h2>
                            <p>ניהול CDN מלא המופעל על ידי הרשת הגלובלית של Cloudflare</p>
                        </div>
                        <div className="cdn-features-grid">
                            <div className="cdn-feature-card">
                                <div className="cdn-feature-icon">
                                    <i className="las la-globe"></i>
                                </div>
                                <h3>רשת קצה גלובלית</h3>
                                <p>הרשת הגלובלית של Cloudflare הכוללת מרכזי נתונים בישראל להפצת תוכן במהירות שיא.</p>
                            </div>
                            <div className="cdn-feature-card">
                                <div className="cdn-feature-icon">
                                    <i className="las la-shield-alt"></i>
                                </div>
                                <h3>אבטחה מתקדמת</h3>
                                <p>WAF (פיירוול אפליקטיבי) והגנת DDoS כדי לשמור על האתר שלכם מאובטח מפני התקפות.</p>
                            </div>
                            <div className="cdn-feature-card">
                                <div className="cdn-feature-icon">
                                    <i className="las la-tachometer-alt"></i>
                                </div>
                                <h3>אופטימיזציית ביצועים</h3>
                                <p>אופטימיזציה מתמדת הכוללת אסטרטגיות מטמון (Caching), דחיסה וכיוונון הפצת התוכן.</p>
                            </div>
                            <div className="cdn-feature-card">
                                <div className="cdn-feature-icon">
                                    <i className="las la-chart-line"></i>
                                </div>
                                <h3>ניטור בזמן אמת</h3>
                                <p>ניטור רציף של ביצועי ה-CDN, זמינות (Uptime) ואבטחה, לצד טיפול פרואקטיבי בתקלות.</p>
                            </div>
                            <div className="cdn-feature-card">
                                <div className="cdn-feature-icon">
                                    <i className="las la-video"></i>
                                </div>
                                <h3>הפצת וידאו</h3>
                                <p>סטרימינג והפצת וידאו מיטביים להפצה חלקה של תכני מדיה.</p>
                            </div>
                            <div className="cdn-feature-card">
                                <div className="cdn-feature-icon">
                                    <i className="las la-layer-group"></i>
                                </div>
                                <h3>תמיכה בריבוי דומיינים</h3>
                                <p>ניהול של עד 4 דומיינים כלול במנוי החודשי שלכם.</p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* What's Included Section */}
                <section className="cdn-included">
                    <div className="container">
                        <div className="cdn-section-header">
                            <h2>מה כלול בשירות</h2>
                            <p>שירותי ניהול CDN מקיפים</p>
                        </div>
                        <div className="cdn-included-grid">
                            <div className="cdn-included-column">
                                <h3><i className="las la-check-circle"></i> תפעול CDN</h3>
                                <ul>
                                    <li><i className="las la-angle-left"></i> הגדרה והקמת CDN</li>
                                    <li><i className="las la-angle-left"></i> אופטימיזציית מדיניות מטמון</li>
                                    <li><i className="las la-angle-left"></i> ניטור הפצת תוכן</li>
                                    <li><i className="las la-angle-left"></i> כיוונון ביצועים</li>
                                </ul>
                            </div>
                            <div className="cdn-included-column">
                                <h3><i className="las la-check-circle"></i> פלטפורמת Cloudflare</h3>
                                <ul>
                                    <li><i className="las la-angle-left"></i> רשת קצה גלובלית</li>
                                    <li><i className="las la-angle-left"></i> איזון עומסים (Load Balancing)</li>
                                    <li><i className="las la-angle-left"></i> ניהול DNS</li>
                                    <li><i className="las la-angle-left"></i> תעודות SSL/TLS</li>
                                </ul>
                            </div>
                            <div className="cdn-included-column">
                                <h3><i className="las la-check-circle"></i> תכונות אבטחה</h3>
                                <ul>
                                    <li><i className="las la-angle-left"></i> WAF (פיירוול אפליקטיבי)</li>
                                    <li><i className="las la-angle-left"></i> הגנת DDoS</li>
                                    <li><i className="las la-angle-left"></i> ניהול בוטים</li>
                                    <li><i className="las la-angle-left"></i> הגבלת קצב (Rate Limiting)</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Pricing Section */}
                <section className="cdn-pricing">
                    <div className="container">
                        <div className="cdn-pricing-card">
                            <div className="cdn-pricing-header">
                                <h2>שירות CDN מנוהל</h2>
                                <p>ניהול CDN מלא לתשתית שלכם</p>
                            </div>
                            <div className="cdn-pricing-body">
                                <div className="cdn-pricing-amount">
                                    <span className="cdn-price">$139.90</span>
                                    <span className="cdn-period">חודשי / USD</span>
                                </div>
                                <ul className="cdn-pricing-features">
                                    <li><i className="las la-check"></i> ניהול תפעולי מלא של ה-CDN</li>
                                    <li><i className="las la-check"></i> רשת גלובלית של Cloudflare</li>
                                    <li><i className="las la-check"></i> ניהול של עד 4 דומיינים</li>
                                    <li><i className="las la-check"></i> ניטור ואופטימיזציה 24/7</li>
                                    <li><i className="las la-check"></i> הגדרת WAF והגנת DDoS</li>
                                    <li><i className="las la-check"></i> כיוונון ביצועים</li>
                                    <li><i className="las la-check"></i> אופטימיזציית הפצת וידאו</li>
                                    <li><i className="las la-check"></i> דוחות וניתוחים חודשיים</li>
                                </ul>
                                <div className="cdn-pricing-note">
                                    <i className="las la-info-circle"></i>
                                    <p><strong>הערה:</strong> רישיון/מנוי Cloudflare אינו כלול. השירות מכסה ניהול בלבד.</p>
                                </div>
                                <a href="https://my.epicfinal.com/index.php?rp=/store/managed-services/managed-cdn&language=hebrew&currency=2"
                                    className="cdn-pricing-btn" target="_blank" rel="noopener noreferrer">
                                    התחילו עכשיו
                                </a>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Perfect For Section */}
                <section className="cdn-perfect-for">
                    <div className="container">
                        <div className="cdn-section-header">
                            <h2>מתאים במיוחד עבור</h2>
                            <p>אידיאלי למגוון שימושים ותעשיות</p>
                        </div>
                        <div className="cdn-perfect-grid">
                            <div className="cdn-perfect-card">
                                <i className="las la-shopping-cart"></i>
                                <h4>אתרי מסחר אלקטרוני</h4>
                                <p>הפצה גלובלית מהירה ואבטחה חזקה לחנויות מקוונות</p>
                            </div>
                            <div className="cdn-perfect-card">
                                <i className="las la-newspaper"></i>
                                <h4>מדיה והוצאה לאור</h4>
                                <p>הפצת תוכן בביצועים גבוהים לאתרי חדשות ומדיה</p>
                            </div>
                            <div className="cdn-perfect-card">
                                <i className="las la-play-circle"></i>
                                <h4>פלטפורמות וידאו</h4>
                                <p>סטרימינג והפצת וידאו אופטימליים לכל העולם</p>
                            </div>
                            <div className="cdn-perfect-card">
                                <i className="las la-building"></i>
                                <h4>אתרי ארגונים</h4>
                                <p>CDN גמיש וניתן להרחבה לאתרי חברות עם תעבורה גבוהה.</p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* CTA Section */}
                <section className="cdn-cta">
                    <div className="container">
                        <div className="cdn-cta-content">
                            <h2>מוכנים לבצע אופטימיזציה להפצת התוכן שלכם?</h2>
                            <p>תנו למומחים שלנו לנהל את תשתית ה-CDN שלכם, בזמן שאתם מתמקדים בעסק שלכם.</p>
                            <div className="cdn-cta-buttons">
                                <a href="https://my.epicfinal.com/index.php?rp=/store/managed-services/managed-cdn&language=hebrew&currency=2"
                                    className="btn-cdn btn-light" target="_blank" rel="noopener noreferrer">
                                    הזמינו שירות
                                </a>
                                <a href="https://meetings.hubspot.com/viacheslav-seifer"
                                    className="btn-cdn btn-outline" target="_blank" rel="noopener noreferrer">
                                    קבעו שיחת ייעוץ
                                </a>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default ManagedCDNHe;
